const $ = window.$;
const Vue = window.Vue;
import {getSizedImageUrl} from '@shopify/theme-images';

const headerApp = new Vue({
  el: '.shopify-section.header',
  data: {
    fixed_header: false,
    header_height: 70,
    header_padding: 0,
    show_menu: false,
    touched_menu_item: '',
    is_desktop: null,
    is_mediastation: window.mediastation,
    collection_products: {
      '/collections/new-sneakers': [],
      '/collections/sneaker-releases': [],
      '/collections/sale': [],
      '/collections/accessories': [],
    },
    show_search: false,
    searchInputText: window.search_terms,
  },
  created() {
    window.addEventListener('resize', this.resizeWindow);
    this.resizeWindow();
    this.loadCollectionProducts();
  },
  destroyed() {
    window.removeEventListener('scroll', this.updateFixedHeader);
    window.removeEventListener('resize', this.resizeWindow);
  },
  watch: {
    // add show_menu class to body element
    show_menu(val) {
      if (val) {
        $('body').addClass('show_menu');
      } else {
        $('body').removeClass('show_menu');
      }
    },
    fixed_header(val) {
      if (val) {
        $('body').addClass('fixed-header');
      } else {
        $('body').removeClass('fixed-header');
        this.show_search = false;
      }
    },
    header_padding(val) {
      $('body').css('padding-top', val);
    },
  },
  methods: {
    touchMenuItem(title) {
      $('#nav-main .toolbar input[type="search"]').blur();
      this.touched_menu_item = (this.touched_menu_item === title) ? '' : title;
    },
    toggleMobileMenu() {
      this.show_menu = !this.show_menu;
    },
    resizeWindow() {
      this.window_width = $(window).prop('innerWidth');
      const isDesktopOld = this.is_desktop;
      this.is_desktop = (this.window_width >= 992);
      const hasDeskTopChanged = (isDesktopOld !== this.is_desktop);

      // reinit if desktop has changed
      if (hasDeskTopChanged) {
        // reset menu & sidebar
        this.show_menu = false;
        this.touched_menu_item = '';
        this.updateSidebarVisibility();

        if (!this.is_desktop) {
          // stop scrolling when switched to mobile
          if (isDesktopOld === true) {
            window.removeEventListener('scroll', this.updateFixedHeader);
          }
          // fixed header settings on mobile
          this.fixed_header = false;
          this.header_padding = 70;
        }
      }

      // reset header fixing with new header height
      if (this.is_desktop) {
        this.initFixedHeader();
      }
    },
    initFixedHeader() {
      if (this.is_mediastation) {
        return;
      }
      window.removeEventListener('scroll', this.updateFixedHeader);
      this.header_height = $('.shopify-section.header').height();
      window.addEventListener('scroll', this.updateFixedHeader);
      this.updateFixedHeader();
    },
    updateFixedHeader() {
      const scrollTop = $(window).scrollTop();
      this.fixed_header = (scrollTop > this.header_height);
      this.header_padding = this.fixed_header ? this.header_height : 0;
    },
    updateSidebarVisibility() {
      let $navFilter = $('#nav-filter-findify');
      if (!$navFilter.length) {
        $navFilter = $('#nav-filter');
      }
      if (this.is_desktop) {
        $navFilter.addClass('show');
      } else {
        $navFilter.removeClass('show');
      }
    },
    moveNewsletterToFindify() {
      const $asideFindify = $('section.collection-products .findify-search aside');
      const $asideFallback = $('section.collection-products .findify-fallback aside');
      if ($asideFindify.length) {
          const $alert = $asideFallback.find('footer');
          if (this.is_desktop) {
            $alert.appendTo($asideFindify);
        } else {
            $alert.appendTo($asideFindify.parent());
        }
      }
    },
    loadCollectionProducts() {
      if (!this.is_desktop) {
        return;
      }

      const hasSessionStorage = window.sessionStorage;
      const dt = new Date();
      const now = dt.getTime();
      let collectionProducts = null;

      if (hasSessionStorage) {
        const collectionProductsTimeout = window.sessionStorage.getItem('collection_products_timeout');
        collectionProducts = window.sessionStorage.getItem('collection_products_v3');
        if (collectionProducts && collectionProductsTimeout && (collectionProductsTimeout > now)) {
          this.collection_products = JSON.parse(collectionProducts);
          return;
        }
      }

      /* eslint-disable-next-line no-unused-vars */
      $.each(this.collection_products, (key, value) => {
        $.getJSON(`${key}/products.json?limit=8`).done((response) => {
          if (!response.products || !response.products.length) return;
          
          for (let i = 0; i < response.products.length; i++) {
            const item = response.products[i];
            if (!item.images || !item.images.length) continue;

            this.collection_products[key].push({
              title: item.title,
              url: `/products/${item.handle}`,
              img: getSizedImageUrl(item.images[0].src, '600x'),
              imgSmall: getSizedImageUrl(item.images[0].src, '300x'),
              price: (item.variants && item.variants.length) ? item.variants[0].price : 0,
              compare_at_price: (item.variants && item.variants.length) ? item.variants[0].compare_at_price : 0,
            });

            if (this.collection_products[key].length === 4) break;
          }

          if (hasSessionStorage) {
            window.sessionStorage.setItem('collection_products_v3', JSON.stringify(this.collection_products));
            window.sessionStorage.setItem('collection_products_timeout', (now + (1000 * 60 * 60)));
          }

        });
      });
    },
    openFixedHeaderSearch() {
      this.show_search = true;
      this.$nextTick(() => {
        this.$refs.fixedHeaderSearchInput.focus();
      });
    },
    closeFixedHeaderSearch(e) {
      if (e && e.relatedTarget) {
        if (this.$refs.fixedHeaderSearch.contains(e.relatedTarget)) return;
      }
      this.show_search = false;
    }
  },
});

window.headerApp = headerApp;
